import { useTranslation } from 'react-i18next'

import DownArrowIcon from '@wwt/shared/assets/icons/outline/arrow-down.svg'

import { Button, ButtonProps } from './Button'

interface SeeMoreProps extends ButtonProps {
	isOpened: boolean
}

export const SeeMore = ({ isOpened, ...props }: SeeMoreProps) => {
	const { t } = useTranslation()

	return (
		<Button
			className="flex h-fit w-full justify-start px-1 py-1 hover:text-gray-300"
			variant="link"
			data-state={isOpened ? 'open' : 'close'}
			{...props}
		>
			<span className="ts-hyperlink-button-2">
				{isOpened ? t('see.seeLess') : t('see.seeMore')}
			</span>

			<DownArrowIcon className="size-5! duration-200 [[data-state='open']>&]:rotate-180" />
		</Button>
	)
}
